import { render, staticRenderFns } from "./Mta.vue?vue&type=template&id=0bca2fbe&scoped=true&"
import script from "./Mta.vue?vue&type=script&lang=js&"
export * from "./Mta.vue?vue&type=script&lang=js&"
import style0 from "./Mta.vue?vue&type=style&index=0&id=0bca2fbe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca2fbe",
  null
  
)

export default component.exports